"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchEventType = void 0;
var SearchEventType;
(function (SearchEventType) {
    SearchEventType["ShowSearchPopup"] = "Show search popup";
    SearchEventType["DeleteHistory"] = "DeleteHistory";
    SearchEventType["TextClick"] = "TextClick";
})(SearchEventType || (exports.SearchEventType = SearchEventType = {}));
//# sourceMappingURL=SearchEventType.js.map